<template>
  <div class="text-left">
    <b-card-group deck>
      <b-card class="mb-5" header="Manage Category" header-tag="header">
        <b-form>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Category Name:">
                <b-form-input v-model="categoryName" type="text" placeholder="Enter Category Name"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group label="Category Description:">
                <b-form-textarea
                  v-model="categoryDescription"
                  type="text"
                  placeholder="Enter Category Description"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group label="Parent Category">
                <v-select
                  :searchable="false"
                  :clearable="false"
                  :multiple="false"
                  v-model="parentCategory"
                  :options="parentCategoryOptions"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-right mt-4">
              <b-button variant="outline-success">Add & Save</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
// import { HTTP } from "../../utils/HTTP";
import vSelect from "vue-select";
export default {
  name: "ClientProfileManageCategory",
  components: {
    vSelect
  },
  data() {
    return {
      form: {
        categoryName: null,
        categoryDescription: null,
        parentCategory: null
      }
    };
  },

  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
</style>
